var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTopStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#top_star_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.484 1.43C6.94.12 5.144.197 4.621 1.462a20.14 20.14 0 0 0-.663 1.884 19.53 19.53 0 0 0-2.134.068C.462 3.54-.117 5.224.97 6.118a14.872 14.872 0 0 0 1.62 1.146v.005a18.295 18.295 0 0 0-.634 2.325c-.267 1.345 1.182 2.394 2.363 1.626a13.808 13.808 0 0 0 1.7-1.318c.608.56 1.141.984 1.725 1.362 1.189.768 2.599-.312 2.336-1.633a20.46 20.46 0 0 0-.629-2.366c0-.002.002-.003.003-.004.611-.384 1.105-.73 1.569-1.107 1.108-.903.502-2.602-.866-2.725a21.853 21.853 0 0 0-2.052-.08 13.433 13.433 0 0 0-.62-1.919Z",
  fill: "#FACC15"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "top_star_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
})))));
export default SvgTopStar;